module.exports = __webpack_public_path__ + "assets/a689bf9ff084a5a8125f5ad2d6ef30ed.png";